:host {
  display: block;
  max-width: 100%;
  height: auto;
}

.hidden {
  display: none;
}

.title {
  text-transform: uppercase;
  margin-top: calc(var(--spacer) * 3);
  margin-bottom: calc(var(--spacer) * 2);
  &#additional-patch-settings-title {
    margin-bottom: calc(var(--spacer) * 3);
  }
  &#specific-relays-title {
    margin-top: 0;
  }
}

.form-wrapper {
  min-width: 500px;
  width: 100%;
  height: auto;
  overflow-y: scroll;
  .flex-group {
    display: flex;
  }
}

.form-section {
  max-width: 800px;
  width: 100%;
  height: auto;
  display: flex;
  margin-top: var(--spacer);
  align-items: flex-start;
  flex-direction: column;
  .flex-group {
    display: flex;
  }
  gz-title {
    margin-bottom: calc(var(--spacer) * 3);
  }
}

.subsection-title {
  color: var(--chart-300-icon-buttons);
  margin-top: calc(var(--spacer) * 3);
  margin-bottom: calc(var(--spacer) * 2);
  text-transform: uppercase;
  &#specific-relays-title {
    margin-top: 0;
  }
}

.subsection-description {
  color: var(--chart-300-icon-buttons);
  margin-bottom: calc(var(--spacer) * 3);
  line-height: 1.15;
}

#fallback-schedule-notice-container {
  max-width: 800px;
  margin: calc(var(--spacer) * 3) 0 calc(var(--spacer) * 4);
  line-height: 21px;
}

#operation-targeted-labeled-content,
#patch-scope-labeled-content {
  width: 100%;
  .flex-group {
    margin-top: calc(var(--spacer));
    margin-left: calc(var(--spacer) * 2);
  }
  .manually-approved-content {
    margin-left: 26px;
  }
  .manually-approved-scope-section {
    margin-top: calc(var(--spacer) * 3);
    gz-checkbox {
      width: auto;
    }
  }
  #manually-approved-patches-info-text {
    width: 538px;
    white-space: normal;
    color: var(--body-text-arrows-400);
  }
  gz-maintenance-window-manually-approved-patches-selector {
    margin-top: calc(var(--spacer) * 2);
  }
}

#operation-targeted-labeled-content {
  margin-bottom: calc(var(--spacer));
}

#patch-scope-labeled-content {
  margin-bottom: calc(var(--spacer) * 2);
}

#vendors-products-to-be-labeled-content {
  gz-radio-group {
    margin-left: calc(var(--spacer) * 2);
    gz-radio {
      margin-right: calc(var(--spacer) * 4);
    }
  }
}

gz-maintenance-window-patch-management-vendor-product-selector {
  margin-left: calc(var(--spacer) * 2);
  padding-top: calc(var(--spacer) - 6px);
}

#run-on-system-changes-form-field,
#use-same-schedule-form-field,
#use-fallback-schedule-form-field {
  height: 32px;
  display: flex;
  align-items: center;
  margin-bottom: var(--spacer);
}

.run-on-system-changes-subsection {
  display: flex;
  align-items: center;
  width: 100%;
}

.tooltip {
  margin-left: var(--spacer);

  span {
    font-size: 25px;
  }
}
